import React from "react";
import {
  DashboardEmptyState,
  HubTableTemplate,
} from "../../components";

const items = [
  { id: "name", label: "Customer" },
  { id: "industry", label: "Industry" },
  { id: "active", label: "Active" },
  { id: "creationDate", label: "Created" },
  { id: "createdBy", label: "Created By" },
];

const keys = [
  {
    variant: "blueBold",
    value: "name",
    navigate: true,
    route: "customers",
    id: "id",
  },
  { value: "industry.name", defaultValue: "—" },
  { value: "active", isBoolean: true },
  { value: "creationDate", isDate: true },
  { value: "createdBy", isUser: true, userProps: { size: "18px" } },
];

export const RecentCustomersTable = ({ rows = [], isLoading }) => {
  if (!isLoading && !rows.length) {
    return (
      <DashboardEmptyState
        icon="Users"
        title="No recent customers"
        subtitle="New customer records will appear here."
      />
    );
  }
  return (
    <HubTableTemplate
      id="dashboard-recent-customers"
      headerProps={{ items }}
      bodyProps={{ items: rows, keys }}
      isLoading={isLoading}
    />
  );
};

export default RecentCustomersTable;
